import { ReactNode, SVGAttributes } from 'react';
import { joinClassNames } from '../../../../utils';
import styles from './styles.module.scss';

export type BaseIllustrationProps = SVGAttributes<SVGElement> & {
  children: ReactNode;
  title?: string;
  desc?: string;
};

export const BaseIllustration = ({ children, title, desc, className, ...props }: BaseIllustrationProps) => (
  <svg
    role="img"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={joinClassNames(styles.baseIllustration, className)}
    {...props}
  >
    {title && <title>{title}</title>}
    {desc && <desc>{desc}</desc>}
    {children}
  </svg>
);
